import { ISelectionRange } from '../quill/types';
import Event from './Event';
import Events from './Events';

export default class SelectionChangeEvent extends Event {
    public attributes: {[key: string]: any};
    public range: ISelectionRange | null;

    constructor(range: ISelectionRange | null, attributes: {[key: string]: any}) {
        super(Events.SelectionChange);
        this.attributes = attributes;
        this.range = range;
    }
}
